import { region } from "./region";
import {miniPersistStore} from "../models/MiniPersistStore";
import {
    StorageDriversInfType,
} from "../models/TeamStore";
import {DriverInfType} from "../models/DriverStore";
import Fetcher from "@netless/fetch-middleware";
import {ServiceTypeEnum} from "../components/portal/serviceCenter/ProjectDetail";
if (!process.env.CONSOLE_LAMBDA_ORIGIN) {
    throw new Error("need set process.env.CONSOLE_LAMBDA_ORIGIN");
}
const fetcher = new Fetcher(10000, process.env.CONSOLE_LAMBDA_ORIGIN);

export class ServiceDriverOperator {

    public async getStorageDriversList(type?: ServiceTypeEnum): Promise<any> {
        const json = await fetcher.get<any>({
            path: "storage-drivers",
            query: {
                token: miniPersistStore.token,
                type: type,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async getStorageDriverById(id: number): Promise<any> {
        const json = await fetcher.get<any>({
            path: `storage-drivers/${id}`,
            query: {
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }


    public async submitStorageDriverInf(storageDriversInfType: StorageDriversInfType): Promise<any> {
        const json = await fetcher.post<any>({
            path: "storage-drivers",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                ak: storageDriversInfType.ak,
                sk: storageDriversInfType.sk,
                bucket: storageDriversInfType.bucket,
                region: storageDriversInfType.region,
                path: storageDriversInfType.path,
                provider: storageDriversInfType.provider,
                domain: storageDriversInfType.domain,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async upDateStorageDriverInf(storageDriversInfType: StorageDriversInfType, storageId: number): Promise<any> {
        const json = await fetcher.put<any>({
            path: `storage-drivers/${storageId}`,
            query: {
                token: miniPersistStore.token,
            },
            body: {
                ak: storageDriversInfType.ak,
                sk: storageDriversInfType.sk,
                bucket: storageDriversInfType.bucket,
                region: storageDriversInfType.region,
                path: storageDriversInfType.path,
                provider: storageDriversInfType.provider,
                domain: storageDriversInfType.domain,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async deleteStorageDriverById(id: number): Promise<any> {
        const json = await fetcher.delete<any>({
            path: `storage-drivers/${id}`,
            query: {
                token: miniPersistStore.token,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    // Service

    public async getServiceState(type: ServiceTypeEnum): Promise<any> {
        const json = await fetcher.get<any>({
            path: "services",
            query: {
                token: miniPersistStore.token,
                type: type,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async submitServiceDriver(driverInfType: DriverInfType): Promise<any> {
        const json = await fetcher.post<any>({
            path: "services",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                type: driverInfType.type,
                configuration: {
                    storageDriverId: driverInfType.configuration.storageDriverId,
                    defaultStorageDriver: driverInfType.configuration.defaultStorageDriver,
                },
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async upDateServiceDriver(driverInfType: DriverInfType): Promise<any> {
        const json = await fetcher.put<any>({
            path: "services",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                type: driverInfType.type,
                configuration: {
                    storageDriverId: driverInfType.configuration.storageDriverId,
                    defaultStorageDriver: driverInfType.configuration.defaultStorageDriver,
                },
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async switchServiceState(service: ServiceTypeEnum, state: boolean): Promise<any> {
        const json = await fetcher.put<any>({
            path: "services/states",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                type: service,
                enable: state,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    // QPS
    public async getServiceQPS(service: ServiceTypeEnum): Promise<any> {
        const json = await fetcher.get<any>({
            path: "concurrent-settings",
            query: {
                token: miniPersistStore.token,
                serviceType: service,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }

    public async upDateServiceQPS(service: ServiceTypeEnum, number: number): Promise<any> {
        const json = await fetcher.put<any>({
            path: "concurrent-settings",
            query: {
                token: miniPersistStore.token,
            },
            body: {
                serviceType: service,
                maxConcurrentNumber: number,
            },
            headers: {
                region,
            },
        });
        return json as any;
    }
}



// WEBPACK FOOTER //
// ./src/apiMiddleware/ServiceDriverOperator.ts